module.exports = __webpack_public_path__ + "media/images/badges/clubpilates/milestone-3-Active-ClubPilates-c6e424cca9843d102d21b0f0e04a9da7.png";